import React from "react";
import GuidePanel from "../GuidePanel.js";
import {
  GuideLead,
  GuideCallout,
  GuideCompare,
  GuideBlockList,
} from "../GuideBlocks.js";

const EventVsInterpretationSection = ({ heading, accentIndex = 3, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="event-vs-interpretation"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      One of the biggest sources of stress is confusing an event with our interpretation of that event.
    </GuideLead>
    <GuideCompare
      leftTitle="Event"
      rightTitle="Interpretation"
      left={
        <>
          <p>An event is simply what happened.</p>
          <p>
            <strong>Example:</strong> Your colleague did not reply to your email.
          </p>
        </>
      }
      right={
        <GuideBlockList
          items={[
            "They are ignoring me.",
            "They don't respect me.",
            "I must have done something wrong.",
            "Something bad is going to happen.",
          ]}
        />
      }
    />
    <p className="guide-panel__p">Notice that none of these interpretations are facts. They are stories your mind creates to explain uncertainty.</p>
    <p className="guide-panel__p">
      The problem is that we often react to the story instead of the actual event.
    </p>
    <GuideCallout variant="amber">
      Learning to separate events from interpretations is one of the most valuable thinking skills
      you can develop.
    </GuideCallout>
  </GuidePanel>
);

export default EventVsInterpretationSection;
